import { Link } from "react-router-dom";
import { C } from "../constants";
import { Sec, STitle } from "../components/Shared";

const pStyle = {
  fontFamily: "'Nunito', sans-serif", fontSize: 15, color: C.textMid,
  lineHeight: 1.75, margin: "0 0 14px"
};
const liStyle = {
  fontFamily: "'Nunito', sans-serif", fontSize: 15, color: C.textMid,
  lineHeight: 1.75, marginBottom: 10
};
const linkStyle = { color: C.blue, fontWeight: 600, textDecoration: "none" };

export default function DeleteAccount() {
  return (
    <div>
      <Sec>
        <div style={{ maxWidth: 680, margin: "0 auto" }}>
          {/* Header */}
          <div style={{
            background: `linear-gradient(135deg, ${C.blueLight}, ${C.bluePale})`,
            borderRadius: 16, padding: "32px 36px", marginBottom: 36,
            border: `1px solid ${C.border}`, textAlign: "center"
          }}>
            <span style={{ fontSize: 44, display: "block", marginBottom: 12 }}>🗑️</span>
            <h1 style={{
              fontFamily: "'Nunito', sans-serif", fontWeight: 900,
              fontSize: "clamp(24px, 4vw, 32px)", color: C.text, margin: "0 0 8px"
            }}>Delete Your SafeZapp Account</h1>
            <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: 15, color: C.textMid, margin: 0 }}>
              You can delete your account at any time from within the app.
            </p>
          </div>

          {/* Steps */}
          <h2 style={{
            fontFamily: "'Nunito', sans-serif", fontWeight: 800, fontSize: 20,
            color: C.text, margin: "0 0 20px"
          }}>How to delete your account</h2>

          <ol style={{ paddingLeft: 0, margin: "0 0 28px", listStyle: "none", counterReset: "steps" }}>
            {[
              ["Open SafeZapp", "Launch the SafeZapp app on your device."],
              ["Go to your Profile", "Tap the Profile tab at the bottom of the screen."],
              ["Open the menu", "Tap the three-dot menu (⋮) in the top-right corner."],
              ["Tap \"Cancel my account\"", "Select the account cancellation option from the menu."],
              ["Confirm deletion", "A two-step confirmation will explain what happens next. Confirm to proceed."],
            ].map(([title, desc], i) => (
              <li key={i} style={{
                display: "flex", gap: 16, marginBottom: 20, alignItems: "flex-start"
              }}>
                <div style={{
                  width: 38, height: 38, borderRadius: 10, flexShrink: 0,
                  background: C.blueLight, display: "flex", alignItems: "center", justifyContent: "center",
                  fontFamily: "'Nunito', sans-serif", fontWeight: 900, fontSize: 18, color: C.blueDark
                }}>{i + 1}</div>
                <div>
                  <div style={{
                    fontFamily: "'Nunito', sans-serif", fontWeight: 700, fontSize: 16, color: C.text, marginBottom: 2
                  }}>{title}</div>
                  <div style={{
                    fontFamily: "'Nunito', sans-serif", fontSize: 14.5, color: C.textMid, lineHeight: 1.6
                  }}>{desc}</div>
                </div>
              </li>
            ))}
          </ol>

          {/* What happens */}
          <h2 style={{
            fontFamily: "'Nunito', sans-serif", fontWeight: 800, fontSize: 20,
            color: C.text, margin: "0 0 16px"
          }}>What happens when you delete your account</h2>

          <div style={{
            background: C.white, borderRadius: 14, padding: "22px 26px",
            border: `1px solid ${C.border}`, marginBottom: 20
          }}>
            <ul style={{ paddingLeft: 20, margin: 0 }}>
              <li style={liStyle}>Your account data is <strong style={{ color: C.text }}>archived for 90 days</strong>, then permanently deleted</li>
              <li style={liStyle}>Your login is <strong style={{ color: C.text }}>disabled immediately</strong> — you will not be able to sign back in</li>
              <li style={liStyle}>If you are an Approver, all supervised Users are <strong style={{ color: C.text }}>unlinked</strong></li>
              <li style={liStyle}>Unlinked Users who do not re-link to a new Approver within <strong style={{ color: C.text }}>14 days</strong> will have their accounts automatically deleted</li>
              <li style={{ ...liStyle, marginBottom: 0 }}>After 90 days, <strong style={{ color: C.text }}>all your data is permanently and irreversibly deleted</strong></li>
            </ul>
          </div>

          {/* Data deleted */}
          <h2 style={{
            fontFamily: "'Nunito', sans-serif", fontWeight: 800, fontSize: 20,
            color: C.text, margin: "0 0 16px"
          }}>What data is deleted</h2>

          <div style={{
            background: C.white, borderRadius: 14, padding: "22px 26px",
            border: `1px solid ${C.border}`, marginBottom: 20
          }}>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 12 }}>
              {[
                ["✓", "Account information"],
                ["✓", "Phone number"],
                ["✓", "Display name"],
                ["✓", "Chat messages"],
                ["✓", "Contact lists"],
                ["✓", "Link and pairing records"],
                ["✓", "Subscription data"],
                ["✓", "Push notification tokens"],
              ].map(([icon, label], i) => (
                <div key={i} style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <span style={{ color: C.accent, fontWeight: 700, fontSize: 15 }}>{icon}</span>
                  <span style={{ fontFamily: "'Nunito', sans-serif", fontSize: 14, color: C.textMid }}>{label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Note */}
          <div style={{
            background: C.yellowLight, borderRadius: 12, padding: "16px 20px",
            border: "1px solid rgba(255,215,0,0.3)", marginBottom: 28
          }}>
            <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: 14, color: C.text, lineHeight: 1.7, margin: 0 }}>
              <strong>Note:</strong> Account deletion can only be done from within the SafeZapp app. If you are unable to access the app and need to delete your account, please contact us at{" "}
              <a href="mailto:support@safezapp.app" style={linkStyle}>support@safezapp.app</a>.
            </p>
          </div>

          {/* Links */}
          <div style={{
            background: C.bg, borderRadius: 12, padding: "16px 20px",
            border: `1px solid ${C.border}`, textAlign: "center"
          }}>
            <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: 14, color: C.textMid, margin: 0 }}>
              For more information, see our{" "}
              <Link to="/privacy" style={linkStyle}>Privacy Policy</Link> and{" "}
              <Link to="/terms" style={linkStyle}>Terms of Service</Link>.
            </p>
          </div>
        </div>
      </Sec>
    </div>
  );
}
